/* tslint:disable */

declare var Object: any;
export interface ERPsalesContractInterface {
  "id"?: number;
}

export class ERPsalesContract implements ERPsalesContractInterface {
  "id": number;
  constructor(data?: ERPsalesContractInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ERPsalesContract`.
   */
  public static getModelName() {
    return "ERPsalesContract";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ERPsalesContract for dynamic purposes.
  **/
  public static factory(data: ERPsalesContractInterface): ERPsalesContract{
    return new ERPsalesContract(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'ERPsalesContract',
      plural: 'ERPsalesContracts',
      path: 'ERPsalesContracts',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/ERPsalesContract.ts